
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CollectionMasterGrid extends Serenity.EntityGrid<CollectionMasterRow, any> {
        protected getColumnsKey() { return 'OMS.CollectionMaster'; }
        protected getDialogType() { return CollectionMasterDialog; }
        protected getIdProperty() { return CollectionMasterRow.idProperty; }
        protected getLocalTextPrefix() { return CollectionMasterRow.localTextPrefix; }
        protected getService() { return CollectionMasterService.baseUrl; }
        protected getInsertPermission() { return CollectionMasterRow.insertPermission; }
        protected getUpdatePermission() { return CollectionMasterRow.updatePermission; }
        protected getDeletePermission() { return CollectionMasterRow.deletePermission; }
        protected useViewMode() { return true; }


        constructor(container: JQuery) {
            super(container);
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}